import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtHospitalityCoreFeatureSection({}) {
  const isMobile = useMobile();
  const renderRow = (title, message, containerStyle) => {
    return (
      <View
        style={[
          {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            flexDirection: "row",
            alignItems: "center",
            padding: 18,
            borderRadius: 15,
          },
          containerStyle,
        ]}
      >
        <Image
          style={[
            {
              width: 150,
              height: 300,
              resizeMode: "contain",
            },
          ]}
          source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
        />

        <View style={{ flex: 1, marginLeft: 15 }}>
          <NtSectionTitle style={{ textAlign: "left" }}>{title}</NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 15 }}>
            {message}
          </NtSectionDescription>
        </View>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 800 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/85ea4d3c0b17024ea04ca35763f06f78e2306e39.jpg")}
    >
      <View style={{ width: "100%" }}>
        <NtSectionTitle style={{ textAlign: "left" }}>
          CORE FEATURE
        </NtSectionTitle>
        <NtSectionDescription style={{ marginTop: 8 }}>
          HOTELMATE
        </NtSectionDescription>
        <View
          style={{ flexDirection: isMobile ? "column" : "row", marginTop: 10 }}
        >
          {renderRow(
            "HOTEL NEWS DASHBOARD",
            "Stay informed with the Hotel News Dashboard, your central hub for the latest updates, announcements, and events happening at the property. From special offers to schedule changes, everything you need to know is right at your fingertips.",
            { flex: 1, marginRight: isMobile ? 0 : 10 }
          )}
          {renderRow(
            "VIRTUAL BUTLER CHAT BOT",
            "The Virtual Butler Chat Bot offers guests instant, 24/7 assistance at their fingertips. Whether it's ordering room service, requesting amenities, or getting local recommendations, the chatbot delivers fast, personalized support, enhancing convenience and elevating the guest experience.",
            { flex: 1, marginTop: isMobile ? 10 : 0 }
          )}
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    height: 600,
  },
});

export default NtHospitalityCoreFeatureSection;
